import { useState, useEffect } from "react";

import { loadReturnIndentList } from "../services/returnIndentServise";

const useReturnIndentList = () => {
    const [returnIndentList, setReturnIndentList] = useState([]);
    const [selectReturnIndent, setSelectedReturnIndent] = useState(null);
    const [selectReturnIndentID, setSelectedReturnIndentID] = useState(null);
    const [isIssuedIndentDataLoaded, setIsIssuedIndentDataLoaded] = useState(false);

    // Fetch department data
    const fetchReturnIndent = async (selectedID = null) => {
        const para = { p_company_id: localStorage.getItem("companyid"), p_plant_id: 1 ,p_select_status:'return issued indent'};

        try {
            const data = await loadReturnIndentList(para);
            if (data && data.length > 0) {
                setReturnIndentList(data);
                setIsIssuedIndentDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isIssuedIndentDataLoaded) {
            fetchReturnIndent();
        }
    }, [isIssuedIndentDataLoaded]);

    // Function to load department based on selected ID
    const loadReturnIndentByID = async (selectedID) => {
        await fetchReturnIndent(selectedID);
    };

    return {
        returnIndentList,
        setReturnIndentList,
        selectReturnIndent,
        selectReturnIndentID,
        loadReturnIndentByID,
    };
};

export default useReturnIndentList;
